import { PageHero, SHELL, Reveal, Mono } from "@/components/bits";
import { RISKS } from "@/lib/data";
import { ShieldAlert } from "lucide-react";

export default function Risk() {
    return (
        <div data-testid="risk-page">
            <PageHero
                label="RISK DISCLOSURE"
                title={"SERIOUS INFRASTRUCTURE\nDISCLOSES ITS RISKS."}
                sub="Real-world asset infrastructure involves meaningful risk. This page names it plainly — because credibility begins with honesty."
            />
            <section className="py-20 md:py-28">
                <SHELL>
                    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-16">
                        {RISKS.map((r, i) => (
                            <Reveal key={r.title} delay={i * 0.04}>
                                <div className="glass-card p-7 h-full hover:border-vera-blue/40 transition-colors" data-testid={`risk-card-${i + 1}`}>
                                    <div className="flex items-center justify-between mb-6">
                                        <ShieldAlert className="w-5 h-5 text-vera-soft" strokeWidth={1.5} aria-hidden="true" />
                                        <span className="font-mono text-[10px] text-white/15">{String(i + 1).padStart(2, "0")}</span>
                                    </div>
                                    <h3 className="font-mono text-[11px] tracking-[0.22em] text-vera-white mb-4">{r.title}</h3>
                                    <p className="text-sm text-vera-mut leading-relaxed">{r.text}</p>
                                </div>
                            </Reveal>
                        ))}
                    </div>

                    <Reveal>
                        <div className="border border-vera-gold/30 bg-vera-gold/5 p-8 md:p-10 mb-14" data-testid="risk-commitments">
                            <Mono className="text-vera-gold2 block mb-6">TRANSPARENCY COMMITMENTS</Mono>
                            <ul className="grid sm:grid-cols-2 gap-x-8 gap-y-3">
                                {[
                                    "No invented TVL, APY, AUM, users or investors — ever",
                                    "Demo data is always labeled DEMO or EXAMPLE",
                                    "Official links (buy, chart, contract) are published only on the Token page",
                                    "No partnership or endorsement claims without official proof URLs",
                                ].map((c) => (
                                    <li key={c} className="flex items-start gap-3 text-sm text-vera-mut">
                                        <span className="w-1 h-1 rotate-45 bg-vera-gold mt-2 shrink-0" aria-hidden="true" />
                                        {c}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </Reveal>

                    <Reveal>
                        <p className="text-[11px] text-vera-mut/60 leading-relaxed max-w-3xl">
                            This disclosure is informational and not exhaustive. Nothing on this website is an offer, solicitation or investment
                            advice. VERA does not promise returns, does not present its infrastructure as a regulated investment product, and does not
                            claim that token ownership implies legal ownership of any real-world asset.
                        </p>
                    </Reveal>
                </SHELL>
            </section>
        </div>
    );
}
